import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: flex;
  min-height: 100%;
}

.ops-rail-shell {
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  color: #edf7f1;
}

.ops-rail-lockup {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 18px 2px 16px;
  color: inherit;
  text-decoration: none;
}

.ops-rail-mark {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(226, 245, 235, 0.22);
  background: rgba(226, 245, 235, 0.1);
  color: #dff5e9;
}

.ops-rail-copy {
  min-width: 0;
}

.ops-rail-copy p,
.ops-rail-copy span,
.ops-rail-status-line em,
.ops-stage-heading span,
.ops-stage-next span,
.ops-stage-copy em,
.ops-stage-link .ops-nav-state,
.ops-operator-copy span,
.ops-logout-chip {
  overflow: hidden;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-rail-copy p,
.ops-rail-copy span,
.ops-rail-status-line em,
.ops-stage-heading span,
.ops-stage-next span,
.ops-stage-copy em,
.ops-operator-copy span {
  color: rgba(237, 247, 241, 0.62);
}

.ops-rail-copy h2 {
  margin-top: 4px;
  overflow: hidden;
  color: #ffffff;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.18;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-rail-status-line {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-height: 38px;
  border-top: 1px solid rgba(226, 245, 235, 0.12);
  border-bottom: 1px solid rgba(226, 245, 235, 0.12);
  padding: 0 2px;
}

.ops-rail-status-line strong {
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-stage-nav {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  padding-top: 16px;
}

.ops-stage-heading,
.ops-stage-next {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ops-stage-heading strong,
.ops-stage-next strong {
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
}

.ops-stage-list {
  position: relative;
  display: grid;
  gap: 0;
  margin: 12px 0 0;
  padding: 0 0 0 13px;
  list-style: none;
}

.ops-stage-list::before {
  content: "";
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 26px;
  width: 2px;
  background: rgba(226, 245, 235, 0.14);
}

.ops-stage-list li {
  position: relative;
}

.ops-stage-link {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  min-height: 62px;
  border-bottom: 1px solid rgba(226, 245, 235, 0.1);
  color: rgba(237, 247, 241, 0.76);
  padding: 8px 0 8px 0;
  text-decoration: none;
}

.ops-stage-link.is-active {
  color: #ffffff;
}

.ops-stage-index {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(226, 245, 235, 0.24);
  background: #101915;
  color: rgba(237, 247, 241, 0.72);
  font-size: 11px;
  font-weight: 900;
}

.ops-stage-link.is-complete .ops-stage-index {
  border-color: rgba(125, 211, 169, 0.48);
  background: rgba(31, 122, 77, 0.42);
  color: #dff5e9;
}

.ops-stage-link.is-active .ops-stage-index {
  border-color: #dff5e9;
  background: #dff5e9;
  color: #101915;
}

.ops-stage-copy {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.ops-stage-copy strong {
  overflow: hidden;
  color: inherit;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-stage-link .ops-nav-state {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  border: 1px solid rgba(226, 245, 235, 0.18);
  color: rgba(237, 247, 241, 0.78);
  padding: 0 7px;
}

.ops-stage-link .ops-nav-state.is-current {
  border-color: #dff5e9;
  background: rgba(223, 245, 233, 0.12);
  color: #ffffff;
}

.ops-stage-next {
  margin-top: 14px;
  border-top: 1px solid rgba(226, 245, 235, 0.12);
  padding-top: 12px;
}

.ops-operator-strip {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  border-top: 1px solid rgba(226, 245, 235, 0.12);
  padding: 14px 0 2px;
}

.ops-user-avatar {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  background: #dff5e9;
  color: #101915;
  font-size: 13px;
  font-weight: 900;
}

.ops-operator-copy {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.ops-operator-copy strong {
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-logout-chip {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border: 1px solid rgba(226, 245, 235, 0.16);
  color: rgba(237, 247, 241, 0.78);
  padding: 0 8px;
  text-decoration: none;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public session: any = {};

    public navItems: any[] = [
        { label: '운영 현황', link: '/dashboard', key: '01', shortLabel: '현황', caption: '순찰 상태 확인' },
        { label: '순찰 기준', link: '/villages', key: '02', shortLabel: '기준', caption: '마을별 기준 설정' },
        { label: '순찰 실행', link: '/missions', key: '03', shortLabel: '실행', caption: '드론 자동 순찰 관제' },
        { label: 'AI 확인', link: '/ai-review', key: '04', shortLabel: '확인', caption: '변화 의심 확인' },
        { label: '보고서 작성', link: '/reports', key: '05', shortLabel: '보고', caption: '보고서 생성 및 HWPX 다운로드' }
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.syncSession();
        this.renderNow();
    }

    public syncSession() {
        this.session = this.service.auth?.session || {};
    }

    public renderNow() {
        try {
            this.ref.detectChanges();
        } catch (error) { }
    }

    public isActive(link: string) {
        const pathname = location.pathname;
        if (link === '/dashboard' && pathname === '/') return true;
        return pathname.indexOf(link) === 0;
    }

    public currentStepIndex() {
        const index = this.navItems.findIndex((item: any) => this.isActive(item.link));
        return index >= 0 ? index : 0;
    }

    public currentStepKey() {
        return this.navItems[this.currentStepIndex()]?.key || '01';
    }

    public stepState(item: any) {
        const itemIndex = this.navItems.findIndex((nav: any) => nav.link === item.link);
        const currentIndex = this.currentStepIndex();
        if (itemIndex < currentIndex) return 'complete';
        if (itemIndex === currentIndex) return 'current';
        if (itemIndex === currentIndex + 1) return 'next';
        return 'pending';
    }

    public navLinkClass(item: any) {
        const state = this.stepState(item);
        return state === 'current' ? 'ops-nav-link is-active is-current' : `ops-nav-link is-${state}`;
    }

    public statusClass(item: any) {
        return `ops-nav-state is-${this.stepState(item)}`;
    }

    public statusLabel(item: any) {
        const state = this.stepState(item);
        if (state === 'current') return '현재';
        if (state === 'next') return '다음';
        return '';
    }

    public nextStepLabel() {
        const next = this.navItems[this.currentStepIndex() + 1];
        return next ? next.label : '업무 완료';
    }

    public timestampLabel() {
        const now = new Date();
        const hour = String(now.getHours()).padStart(2, '0');
        const minute = String(now.getMinutes()).padStart(2, '0');
        return `${hour}:${minute}`;
    }

    public userInitial() {
        const name = this.session?.name || '운영';
        return name.charAt(0);
    }

    public userDepartment() {
        return this.session?.department || this.session?.team || this.session?.role || '운영 담당';
    }
}

export default ComponentNavSidebarComponent;